import { render, staticRenderFns } from "./ElectronicFilingStatementAFF.vue?vue&type=template&id=310e60ad"
import script from "./ElectronicFilingStatementAFF.vue?vue&type=script&lang=ts"
export * from "./ElectronicFilingStatementAFF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports